// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"549aba0d","453":"9d69b44f","455":"53e774e4","977":"56deeb8b"}[chunkId] + ".chunk.js";
};